import React, { ComponentProps } from "react";

function CloseRoundedIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_68_79408)">
        <path
          className="icon-bg"
          d="M12.0001 1.70117C5.78616 1.70117 0.75 6.73733 0.75 12.9512C0.75 19.165 5.78616 24.2012 12.0001 24.2012C18.2138 24.2012 23.25 19.165 23.25 12.9512C23.25 6.73733 18.2138 1.70117 12.0001 1.70117Z"
        />
        <path
          className="icon-x"
          d="M15.7954 15.1557C16.2349 15.5951 16.2349 16.307 15.7954 16.7465C15.3557 17.1862 14.6439 17.1859 14.2046 16.7465L12 14.5419L9.79542 16.7465C9.35569 17.1862 8.64394 17.1859 8.20458 16.7465C7.76513 16.307 7.76513 15.5951 8.20458 15.1557L10.4092 12.9511L8.20458 10.7466C7.76513 10.3071 7.76513 9.5952 8.20458 9.15575C8.64403 8.7163 9.35597 8.7163 9.79542 9.15575L12 11.3603L14.2046 9.15575C14.644 8.7163 15.356 8.7163 15.7954 9.15575C16.2349 9.5952 16.2349 10.3071 15.7954 10.7466L13.5908 12.9511L15.7954 15.1557Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_68_79408">
          <rect width={24} height={24} transform="translate(0 0.951172)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CloseRoundedIcon;
